const imBus = {
  namespaced: true,
  state: {
    timjs: undefined,
    imLinkShow: false,
    imiframeApi: undefined,
    logined: false,
    imRoom: {
      imLinkName: undefined,
      imLinkHead: undefined,
      imLinkAccount: undefined,
      imLinkScene: undefined,
      RoomId: undefined,
      userId: undefined,
      inviteID: undefined,
      mediaType: undefined
    },
  },
  mutations: {
    IMLINKSDK: (state, val) => {
      state.timjs = val
    },
    IMLINKSHOW_STATE: (state, obj) => {
      let obj2 = {
        imLinkName: obj.imLinkName,
        imLinkHead: obj.imLinkHead,
        imLinkAccount: obj.imLinkAccount,
        imLinkScene: obj.imLinkScene,
        RoomId: obj.RoomId,
        userId: obj.userId,
        inviteID: obj.inviteID,
        mediaType: obj.mediaType
      }
      state.imRoom = obj2
      state.imLinkShow = obj.imLinkShow
    },
    IMLINK_URL: (state, val) => {
      state.imiframeApi = val
    },
    IMLINK_URL_LOGINED: (state, val) => {
      state.logined = true
    },
  },
  actions: {
    imLinkShowState ({ commit, state, dispatch }, val) {
      commit('IMLINKSHOW_STATE', val)
    },
    imLinkUrl ({ commit, state, dispatch }, val) {
      commit('IMLINK_URL', val)
    },
    imLinkUrlLogined ({ commit, state, dispatch }, val) {
      commit('IMLINK_URL_LOGINED', val)
    },
  },
  getters: {}
}
export default imBus
